import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy, AfterViewInit, NgZone, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { ClientStore, ClientStoreRequest } from 'src/app/stores/stores';
import { getSelectedStore } from '../../+state/stores.selectors';
import { select, Store } from '@ngrx/store';
import { CatalogState } from '../../+state/stores.reducer';
import { takeUntil } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// declare var google: any;

interface OpenTimeDialogData {
  selectedStore: ClientStore;
  tab: 'aboutUs' | 'openTimes';
  schedule: any;
  isClosedForOrdering: boolean;
}

@Component({
  selector: 'app-open-time-modal',
  templateUrl: './open-time-modal.component.html',
  styleUrls: ['./open-time-modal.component.scss']
})
export class OpenTimeModalComponent implements OnInit, OnDestroy, AfterViewInit {
  open = false;
  openTimeSchedule: any;
  selectedStore: ClientStore = null;
  isClosedForOrdering = false;
  selectedStore$: Observable<ClientStore>;
  unsubscribe$: Subject<void> = new Subject<void>();
  map: google.maps.Map;
  selectedTabIndex = 0;
  showAboutUsTab: boolean = true;
  mapInitialized = false;

  @ViewChild('mapWrapper') mapElement: ElementRef;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  addressImageURL: string;
  constructor(
    private store: Store<CatalogState>, 
    private ngZone: NgZone,
    private dialogRef: MatDialogRef<OpenTimeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OpenTimeDialogData,
  ) {}

  ngOnInit(): void {    
    let selectedStore = this.data.selectedStore;
    let tab = this.data.tab;
    this.openTimeSchedule = this.data.schedule;
    this.isClosedForOrdering = this.data.isClosedForOrdering;

    this.store
      .select(getSelectedStore)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        if (selectedStore != null) {
          this.selectedStore = selectedStore;
        } else {
          this.selectedStore = value;
        }

        if (
          this.selectedStore &&
          this.selectedStore.coordinates.latitude &&
          this.selectedStore.coordinates.longitude
        ) {
          if (this.showAboutUsTab && tab === 'aboutUs') {
            this.initializeMap(
              this.selectedStore?.coordinates?.latitude,
              this.selectedStore?.coordinates?.longitude
            );
          }
        }
      });
  }

  ngAfterViewInit(): void {
    this.showAboutUsTab = this.checkAboutUsTabVisibility();
    this.setTabIndex(this.data.tab);
    this.tryInitializeMap();
  }

  tryInitializeMap(): void {
    if (
      this.showAboutUsTab &&
      this.selectedTabIndex === 0 &&
      this.mapElement?.nativeElement &&
      !this.mapInitialized &&
      this.selectedStore?.coordinates?.latitude &&
      this.selectedStore?.coordinates?.longitude
    ) {
      this.initializeMap(
        this.selectedStore.coordinates.latitude,
        this.selectedStore.coordinates.longitude
      );
      this.mapInitialized = true;
    }
  }
  onTabChange(index: number): void {
    // Index 0 refers to the About Us tab
    if (this.showAboutUsTab && index === 0) {
      setTimeout(() => {
        this.initializeMap(
          this.selectedStore?.coordinates?.latitude,
          this.selectedStore?.coordinates?.longitude
        );
      });
    }
  }

  setTabIndex(tabIdentifier: string): void {
    if(tabIdentifier === 'aboutUs') {
      this.selectedTabIndex = this.tabGroup?._tabs.first.position
    }else{
      this.selectedTabIndex = this.tabGroup?._tabs.last.position
    }

    if (tabIdentifier === 'aboutUs') {
      // Initialize the map when the About Us tab is selected
      setTimeout(() => {
        this.initializeMap(
          this.selectedStore?.coordinates?.latitude,
          this.selectedStore?.coordinates?.longitude
        );
      });
    }
  }

  displayOrHideTab(tabIndex: number, displayTab: boolean): void {
    const tabHeaders = document.querySelectorAll('.mdc-tab');
    if (tabHeaders[tabIndex]) {
      (tabHeaders[tabIndex] as HTMLElement).style.display = displayTab ? 'inherit' : 'none';
    }
  }
  initializeMap(lat: number, long: number): void {
    if (!this.mapElement || !this.mapElement.nativeElement) {
      return;
    }

    if (lat && long) {
      const lngLat = new google.maps.LatLng(lat, long);

      const mapOptions = {
        zoom: 13,
        center: lngLat,
        scrollwheel: false
      };

      // Ensure the map is initialized only once
      if (!this.map) {
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        const marker = new google.maps.Marker({
          position: lngLat,
          map: this.map
        });
      }
    }
  }

  checkAboutUsTabVisibility(): boolean {
    const settings = this.selectedStore?.settings;
    let showAboutUsTab = !!(
      this.selectedStore?.phoneNumber?.length > 8 ||
      settings?.STORE_WEBSITE_URL ||
      settings?.DISPLAY_ADDRESS ||
      this.isSocialMediaHandlePresent() ||
      this.isReviewMediaHandlePresent()
    );

    this.showAboutUsTab = showAboutUsTab;
    this.displayOrHideTab(this.tabGroup?._tabs.first.position, showAboutUsTab);
    return showAboutUsTab;
  }

  isSocialMediaHandlePresent(): boolean {
    const settings = this.selectedStore?.settings;
    return !!(
      settings?.FACEBOOK_URL ||
      settings?.INSTAGRAM_URL ||
      settings?.TIKTOK_URL ||
      settings?.TWITTERX_URL ||
      settings?.CARDITIO_URL
    );
  }
  isReviewMediaHandlePresent(): boolean {
    const settings = this.selectedStore?.settings;
    return !!(settings?.GOOGLE_BUSINESS_PAGE_URL || settings?.TRIP_ADVISOR_URL);
  }

  onCheckOutsideClose(event: MouseEvent): void {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
